"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Layout = Layout;
exports.NewMessageButton = NewMessageButton;
exports.MoreButton = MoreButton;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Create = _interopRequireDefault(require("@material-ui/icons/Create"));

var _MoreVert = _interopRequireDefault(require("@material-ui/icons/MoreVert"));

var _Popover = _interopRequireDefault(require("@material-ui/core/Popover"));

var _reactI18next = require("react-i18next");

var Button = function Button(_ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["className"]);
  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, rest, {
    className: (0, _classnames["default"])('rounded-full text-sm font-semibold p-2 shadow-md inline-flex items-center ml-4', className)
  }));
};

function Layout(props) {
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    className: "absolute right-0 top-0"
  }));
}

function NewMessageButton(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(Button, (0, _extends2["default"])({}, props, {
    className: "px-4 text-primary dark:bg-secondary"
  }), /*#__PURE__*/_react["default"].createElement(_Create["default"], {
    fontSize: "small"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml-2"
  }, t('button.newMessage')));
}

var DropdownItem = function DropdownItem(_ref2) {
  var icon = _ref2.icon,
      label = _ref2.label,
      onClick = _ref2.onClick;
  return /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: onClick,
    className: "flex items-center w-40 px-4 py-2  text-gray-light hover:bg-secondary"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mr-2"
  }, icon, " "), /*#__PURE__*/_react["default"].createElement("div", null, label));
};

function MoreButton(_ref3) {
  var actions = _ref3.actions;

  var _React$useState = _react["default"].useState(null),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var handleClick = function handleClick(event) {
    return setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    return setAnchorEl(null);
  };

  var open = Boolean(anchorEl);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Button, {
    onClick: handleClick
  }, /*#__PURE__*/_react["default"].createElement(_MoreVert["default"], null)), /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
    open: open,
    elevation: 2,
    anchorEl: anchorEl,
    onClose: handleClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    PaperProps: {
      className: 'mt-2'
    }
  }, actions.map(function (_ref4) {
    var icon = _ref4.icon,
        label = _ref4.label,
        _onClick = _ref4.onClick;
    return /*#__PURE__*/_react["default"].createElement(DropdownItem, {
      key: label,
      icon: icon,
      label: label,
      onClick: function onClick() {
        _onClick();

        setAnchorEl(null);
      }
    });
  })));
}
//# sourceMappingURL=Action.js.map